import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyBiscuityIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./BiscuityIcon-aeed3592.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyBiscuityIcon as P };
